import { Button } from '@mui/material';
import Typography from '@mui/material/Typography';
import { useContext, useState, useEffect } from 'react';
import '../App.css';
import { v4 as uuidv4 } from 'uuid';
import CombinedTableDisplay from './CombinedTableDisplay'
import CustomSnackbar from '../CustomSnackbar';
import { SystemContext } from "../context";
import ReactDOM from 'react-dom';
import IconButton from '@mui/material/IconButton';
import DownloadIcon from '@mui/icons-material/Download';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

import axios from 'axios';

const FullTextTooltip = ({ text, position }) => {
    if (!position) return null;

    return ReactDOM.createPortal(
        <div style={{
            position: 'fixed',
            left: `${position.x}px`,
            top: `${position.y}px`,
            transform: 'translate(-50%, -100%)',
            backgroundColor: 'white',
            border: '1px solid #ccc',
            padding: '8px',
            zIndex: 9999,
            boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
            maxWidth: '300px',
            wordBreak: 'break-word',
            // textAlign: 'center',
            pointerEvents: 'none',
            marginLeft: '185px',
            marginTop: '25px'
        }}>
            {text}
        </div>,
        document.body
    );
};



const UploadAndCleanData = ({ fetchAPI }) => {

    // const [numericalModeList, setNumericalModeList] = useState(["Mean", "Mode", "Median", "Forward fill", "Backward fill", "Interpolation", "KNN Imputer", "Iterative Imputer"]);
    // const [outlierMethodList, setOutlierMethodList] = useState(["None", "Univariate", "MultiVariate"]);
    // const [categoricalModeList, setCategoricalModeList] = useState(["Mode", "Forward fill", "Backward fill"]);
    // const [outliersList, setOutliersList] = useState(["Mahalanobis distance", "Elliptic envelope"]);
    // const [outliersList1, setOutliersList1] = useState(["IQR", "Z-score"]);
    const [jsonData, setJsonData] = useState([]);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [tooltipPosition, setTooltipPosition] = useState(null);
    const [combinedCsvFileKey, setCombinedCsvFileKey] = useState('');
    const { fileName, setFileName, openDrawer } = useContext(SystemContext);
    const [combinedTableData, setCombinedTableData] = useState([]);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [file, setFile] = useState(null);
    const [snackbarType, setSnackbarType] = useState('');
    const [uploadStatusMsg, setUploadStatusMsg] = useState('');

    // const numericalModeOnChange = (evt, value) => {
    //     setNumericalModeValue(value);
    //     setNumericalError(false);
    // }
    // const categoricalModeOnChange = (evt, value) => {
    //     setCategoricalModeValue(value);
    //     setCategoricalError(false);
    // }
    // const outliersModeOnChange = (evt, value) => {
    //     setOutliersValue(value);
    //     setOutlierError(false);
    // }


    const handleFileChange = (event) => {
        if (event.target.files.length > 0) {
            const files = Array.from(event.target.files);
            setFile(files);
            setFileName(files.map(file => file.name).join(', '));
        } 
        else {
            setFile(null)
            setFileName("");
        }
    };

    //     const handleSubmit = async (event) => {
    //     if (!file || file.length === 0) {
    //         alert("Please choose at least one file..");
    //         return;
    //     }

    //     setLoading(true);
    //     event.preventDefault();
    //     const formData = new FormData();

    //     if (Array.isArray(file)) {
    //         file.forEach(f => formData.append('files', f));
    //     } else {
    //         formData.append('files', file);
    //     }

    //     try {
    //         const response = await fetchAPI.post('/process-files', formData, {
    //             headers: {
    //                 Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
    //             }
    //         });

    //         if (response.status === 200) {

    //             const responseData = response.data;
    //             if (responseData.combined_table && Array.isArray(responseData.combined_table)) {
    //                     setCombinedTableData(responseData.combined_table);
    //             }

    //             if (responseData.combined_csv_path) {
    //                 setCombinedCsvPath(responseData.combined_csv_path);
    //             }
    //             setUploadStatusMsg("File processed successfully");
    //             setSnackbarOpen(true);
    //             setSnackbarType("success");
    //         }
    //     } catch (error) {
    //         console.error('Error in uploading file:', error);
    //         const errorMessage = error.response?.data?.detail || `Error processing file: ${error}`;
    //         setUploadStatusMsg(errorMessage);
    //         setSnackbarType("error");
    //         setSnackbarOpen(true);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const handleSubmit = async (event) => {
        if (!file || file.length === 0) {
            alert("Please choose at least one file..");
            return;
        }

        setLoading(true);
        event.preventDefault();

        try {
            const files = Array.isArray(file) ? file : [file];
            const uploadedFiles = [];
            // Create a timestamp folder name in format YYYY-MM-DD-HH-MM-SS
            const timestamp = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19);
            const uid = uuidv4();
            // First, upload all files to S3 using pre-signed URLs
            for (const fileObj of files) {

                if(!fileObj.name.includes("_drw") && !(fileObj.name.includes("Inputs") && fileObj.name.includes(".xlsx"))) {
                    console.log(`Skipping file ${fileObj.name} as it doesn't contain "_drw" in the filename`);
                    continue;
                }

                try {
                    // Get pre-signed URL for this file
                    const payload = {
                        filename: fileObj.name,
                        timestamp: timestamp,
                        uid: uid
                    };

                    const presignedResponse = await fetchAPI.post('/pre_signed_url', payload, {
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                        }
                    });

                    if (!presignedResponse.data || !presignedResponse.data.url) {
                        console.error(`Failed to get pre-signed URL for ${fileObj.name}`);
                        continue; // Skip this file and try the next one
                    }

                    // Extract pre-signed URL data
                    const { url, fields, key } = presignedResponse.data;
                    // console.log(presignedResponse.data)
                    // Create form data for S3 upload
                    const formData = new FormData();

                    for (const [fieldName, fieldValue] of Object.entries(fields)) {
                        formData.append(fieldName, fieldValue);
                    }

                    formData.append('file', fileObj);

                    const uploadResponse = await axios.post(url, formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    });
                    console.log(uploadResponse)
                    if (uploadResponse.status === 204 || uploadResponse.status === 204) {
                        console.log(`File ${fileObj.name} uploaded successfully to S3`);

                        uploadedFiles.push({
                            key: key,
                            filename: fileObj.name
                        });
                    } else {
                        console.error(`Failed to upload ${fileObj.name} to S3: ${uploadResponse.statusText}`);
                    }
                } catch (error) {
                    console.error(`Error uploading file ${fileObj.name}:`, error);
                }
            }

            if (uploadedFiles.length === 0) {
                throw new Error("Failed to upload any files to S3");
            }
            // console.log(uploadedFiles)

            const processResponse = await fetchAPI.post('/process-files', { "files": uploadedFiles, "uid": uid }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                }
            });
            console.log(uploadedFiles, "Printing UID", uid)
            const num_files = uploadedFiles.length
            if (processResponse.status === 202) {

                const processCombinedStats = async (uid, num_files) => {
                    try {
                        const response = await fetchAPI.post('/process-combined-stats',
                            { uid: uid, num_files: num_files },
                            {
                                headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                                }
                            }
                        );

                        if (response.status === 200) {
                            // Combined stats processed successfully
                            console.log("Combined stats processed:", response.data);
                            // Call pollForStatus here
                            pollForStatus(uid);
                        } else if (response.status === 202) {
                            // Still processing, wait and try again
                            console.log("Still processing combined stats, retrying in 2 seconds...");
                            setTimeout(() => processCombinedStats(uid, num_files), 4000);
                        } else {
                            throw new Error(`Unexpected status: ${response.status}`);
                        }
                    } catch (error) {
                        console.error("Error processing combined stats:", error);
                        setLoading(false);
                        setUploadStatusMsg(`Error: ${error.message || error}`);
                        setSnackbarType("error");
                        setSnackbarOpen(true);
                    }
                };


                const pollForStatus = async (uid) => {
                    try {
                        const response = await fetchAPI.post('/process-stats',
                            { uid: uid },
                            {
                                headers: {
                                    'Content-Type': 'application/json',
                                    Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                                }
                            }
                        );

                        if (response.status === 200) {
                            // Process completed successfully
                            const outputData = response.data;
                            console.log("Process completed:", outputData);

                            // Update UI with the returned data
                            if (outputData.json_data.combined_table && Array.isArray(outputData.json_data.combined_table)) {
                                // setCombinedTableData(outputData.json_data.combined_table);
                                const tableData = outputData.json_data.combined_table;
                                // Always remove the last 3 rows from the table data
                                setCombinedTableData(tableData.slice(0, -3));
                            }

                            if (outputData.json_data.output_files && outputData.json_data.output_files.combined_csv) {
                                setCombinedCsvFileKey(outputData.json_data.output_files.combined_csv);
                            }
                            setLoading(false)
                            const tableData = outputData.json_data.combined_table;
                            if(tableData.length === 0) {
                                setUploadStatusMsg("No data available for extraction");
                                setSnackbarOpen(true);
                                setSnackbarType("warning");
                            }
                            else {
                                setUploadStatusMsg("Processing completed successfully");
                                setSnackbarOpen(true);
                                setSnackbarType("success");
                            }
                        } else {
                            console.log("Still processing, polling again in 2 seconds...");
                            setTimeout(() => pollForStatus(uid), 2000);
                        }
                    } catch (error) {
                        setLoading(false)
                        console.error("Error polling for status:", error);
                        const errorMessage = error.response?.data?.detail || `Error: ${error.message || error}`;
                        setUploadStatusMsg(errorMessage);
                        setSnackbarType("error");
                        setSnackbarOpen(true);
                    }
                };

                const num_files = uploadedFiles.length;
                processCombinedStats(uid, num_files);
                setUploadStatusMsg(`Successfully uploaded ${uploadedFiles.length} of ${files.length} files`);
                setSnackbarOpen(true);
                setSnackbarType("success");
            }
        } catch (error) {
            console.error('Error in uploading and processing files:', error);
            const errorMessage = error.response?.data?.detail || `Error: ${error.message || error}`;
            setLoading(false)
            setUploadStatusMsg(errorMessage);
            setSnackbarType("error");
            setSnackbarOpen(true);
        }
        // finally {
        //     setLoading(false);
        // }
    };


    const handleDownloadCSV = async () => {
        if (!combinedTableData || !combinedCsvFileKey) {
            setUploadStatusMsg("No CSV file available to download");
            setSnackbarType("error");
            setSnackbarOpen(true);
            return;
        }

        try {
            setLoading(true);

            // Call the API to get a presigned download URL
            const response = await fetchAPI.post('/download-file', {
                file_key: combinedCsvFileKey
            }, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
                }
            });

            if (response.data && response.data.download_url) {
                // Create a temporary anchor element to trigger the download
                const downloadUrl = response.data.download_url;
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', `${fileName.split('.')[0]}_combined.csv`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                setUploadStatusMsg("CSV file download started");
                setSnackbarType("success");
                setSnackbarOpen(true);
            } else {
                throw new Error("Invalid response from server");
            }
        } catch (error) {
            console.error('Error downloading CSV file:', error);
            setUploadStatusMsg("Error downloading CSV file: " + (error.message || "Unknown error"));
            setSnackbarType("error");
            setSnackbarOpen(true);
        } finally {
            setLoading(false);
        }
    };

        const handleClearFiles = () => {
        setFile(null);
        setFileName('');
        // Clear the file input
        const fileInput = document.getElementById('fileUpload');
        if (fileInput) {
            fileInput.value = '';
        }
        // Clear any related data
        setCombinedTableData([]);
        setCombinedCsvFileKey('');
    };





    // const handleSubmit = async (event) => {
    //     if (file === null) {
    //         alert("Please choose the file..")
    //         return
    //     }
    //     setLoading(true);
    //     event.preventDefault();
    //     const formData = new FormData();
    //     formData.append('files', file);

    //     try {
    //         const response = await fetchAPI.post('/process-files', formData, {

    //         });
    //         // const res= await fetchAPI.post('/pre_signed_url', formData, {
    //         //     headers: {
    //         //         'Content-Type': 'multipart/form-data',
    //         //         Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
    //         //     }
    //         //     body:
    //         // });
    //         // const data = response.data.json_data;
    //         const data = response.data;
    //         if (response.status == 200) {
    //             setUploadStatusMsg(response.data.message)
    //             setSnackbarOpen(true);
    //             setSnackbarType("success")


    //         setNumberOfRows(data['datapoints'])
    //         setNumberOfColumns(data['features'])
    //         setStatsData(data['n_stats'])
    //         setNumericalStatsData(Object.values(data['n_stats']))
    //         setNumericalStatsCol(Object.keys(data['n_stats']))
    //         setCategoricalStatsData(Object.values(data['cstats']))
    //         setCategoricalStatsCol(Object.keys(data['cstats']))
    //         setAllColumns(data['cols'])
    //         setNumberOfDuplicateRows(data['dup_rows'])
    //         setNumberOfDuplicateColumns(data['dup_cols'])
    //         setNumericalColumns(data['num_cols'])
    //         setStringColumns(data['cat_cols'])
    //         setMissingData(data['missing_values']);
    //         setCleanedData([])

    //     } }
    //     catch (error) {
    //         setUploadStatusMsg(error.response.data.message)
    //         console.error('Error in uploading file:', error);
    //         setSnackbarType("error")
    //         setSnackbarOpen(true);
    //     }
    //     setLoading(false);
    // };


    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    const [loading, setLoading] = useState(false);

    const overlayStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1000,
    };

    // const boxStyle = {
    //     borderRadius: "15px",
    //     border: "2px solid #ccc",
    //     padding: "20px",
    //     margin: "20px",
    //     boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    //     backgroundColor: "#f9f9f9",
    //     width: "84vw",
    //     // maxWidth: "1200px",
    //     boxSizing: "border-box",
    //     overflowX: 'auto',
    // };

    // const parentStyle = {
    //     display: "flex",
    //     flexWrap: "wrap",
    //     justifyContent: 'center',
    // };

    // const innerContentStyle = {
    //     display: 'flex',
    //     flexWrap: 'wrap',
    //     justifyContent: 'start',
    //     // maxWidth: '70vw',
    //     flexDirection: 'column',
    // };

    // const rowStyle = {
    //     display: 'flex',
    //     flexDirection: 'row',
    //     alignItems: 'center',
    //     boxSizing: "border-box",
    // };

    // const autocompleteStyle = {
    //     flexGrow: 1,
    //     marginLeft: '1rem',
    //     width: '200px'
    // };

    // const paragraphStyle = {
    //     // minWidth: '250px',
    //     whiteSpace: 'nowrap',
    //     textAlign: 'left',
    //     marginRight: '1rem',
    //     display: 'flex',
    //     flexDirection: 'row'
    // };
    // const labelStyle = {
    //     color: '#152C73',
    //     marginRight: '1rem',
    //     display: 'flex',
    // };
    // const nameStyle = {
    //     fontWeight: 'bold',
    //     whiteSpace: 'nowrap',
    //     overflow: 'hidden',
    //     textOverflow: 'ellipsis',
    //     maxWidth: '350px', // Adjust based on your requirement
    //     // position: 'relative',
    // };

    // const lastAccessStyle = {
    //     fontSize: '0.85em',
    //     color: 'grey',
    // };

    // const optionStyles = {
    //     display: 'flex',
    //     flexDirection: 'column',
    //     padding: '15px 5px',
    //     whiteSpace: 'nowrap',
    //     position: 'relative',

    // };

    // const fullTextStyle = {
    //     position: 'absolute',
    //     top: '100%',
    //     left: 0,
    //     whiteSpace: 'wrap',
    //     backgroundColor: 'white',
    //     border: '1px solid #ccc',
    //     padding: '3px',
    //     zIndex: 1000,
    //     display: 'block',
    //     // overflow:'auto'
    //     boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
    //     maxWidth: '100%',
    //     // wordBreak: 'break-word'
    // };

    // const optionContainerStyle = {
    //     position: 'relative',
    //     display: 'flex',
    //     flexDirection: 'column',
    // };

    // const handleMouseEnter = (event, index) => {
    //     const rect = event.currentTarget.getBoundingClientRect();
    //     setHoveredIndex(index);
    //     setTooltipPosition({ x: rect.left, y: rect.bottom + window.scrollY });
    // };

    // const handleMouseLeave = () => {
    //     setHoveredIndex(null);
    //     setTooltipPosition(null);
    // };

    useEffect(() => {
        // const fetchJsonData = async () => {
        //     try {
        //         const response = await fetchAPI.get('/user_jobs', {
        //             headers: {
        //                 'Content-Type': 'application/json',
        //                 Authorization: `Bearer ${localStorage.getItem("msal.idtoken")}`,
        //             }
        //         });
        //         const data = response.data.job_list
        //         setJsonData(data);
        //     } catch (error) {
        //         console.error('Error fetching JSON data:', error);
        //     }
        // };
        // fetchJsonData();
    }, );
    return (
        <>
            <form>
                <div style={{ display: 'flex', width: 'auto', flexDirection: 'row', marginTop: '2rem', marginBottom: '2rem', alignItems: 'center', justifyContent: 'center' }}>

                    {/* <Autocomplete
                        options={jsonData}
                        getOptionLabel={(option) => option.name}
                        renderOption={(props, option, { index }) => (
                            <li
                                {...props}
                                style={optionStyles}
                                onMouseEnter={(e) => handleMouseEnter(e, index)}
                                onMouseLeave={handleMouseLeave}
                            >
                                <div style={optionContainerStyle}>
                                    <span style={nameStyle}>{option.name}</span>
                                </div>
                                <span style={lastAccessStyle}>Last accessed: {option.last_access}</span>
                            </li>
                        )}
                        renderInput={(params) => <TextField {...params} label="Old workspace" />}
                        sx={{ height: '15%', minWidth: '380px', width: 'auto', margin: '10px' }}
                        ListboxProps={{
                            style: { maxHeight: '300px', overflow: 'auto' }
                        }}
                    /> */}
                    <FullTextTooltip
                        text={hoveredIndex !== null ? jsonData[hoveredIndex].name : ''}
                        position={tooltipPosition}
                    />

                    {/* <div>
                        <label htmlFor="jsonDataDropdown">Select from JSON data:</label>
                        <select id="jsonDataDropdown" style={{ width: '250px', margin: '15px' }} style={dropdown}>
                            {jsonData.map((item, index) => (
                                <option key={index} value={item.name}>
                                    {item.name} - Last accessed: {item.last_access}
                                </option>
                            ))}
                        </select>
                    </div> */}



                    <div class="input_container" style={{ position: 'relative', display: 'inline-block' }}>
                        <input type="file" id="fileUpload"
                            accept=".pdf,.xlsx"
                            multiple
                            onChange={handleFileChange} />
                        {fileName && (
                            <button
                                type="button"
                                onClick={handleClearFiles}
                                style={{
                                    position: 'absolute',
                                    right: '5px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    background: '#ff4444',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '20px',
                                    height: '20px',
                                    cursor: 'pointer',
                                    fontSize: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    zIndex: 1
                                }}
                                title="Clear selected files"
                            >
                                X
                            </button>
                        )}
                    </div>
                    <div>
                        <Button variant="contained"
                            component="label"
                            role={undefined}
                            tabIndex={-1}
                            startIcon={<CloudUploadIcon />}
                            style={{ display: 'flex', marginLeft: '1rem', borderRadius: '16px', background: fileName !== "" ? "#3f51b5" : ""}}
                            onClick={handleSubmit}
                            z disabled={fileName === ""}
                        >Upload and Process</Button>
                    </div>

                </div>

            </form>
            <CustomSnackbar open={snackbarOpen} onClose={handleSnackbarClose} snackbarType={snackbarType}
                message={
                    snackbarType === 'success' ? uploadStatusMsg :
                        snackbarType === 'warning' ? uploadStatusMsg :
                            snackbarType === 'error' ? uploadStatusMsg :
                                ""
                }
            />

            {combinedTableData.length > 0 && (
                <div style={{
                    display: 'flex',
                    width: 'auto',
                    marginTop: '2rem',
                    marginBottom: '1rem',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderBottom: '2px solid #e0e0e0',
                    paddingBottom: '0.5rem',
                    maxWidth: '95%',
                    margin: '2rem auto 1rem'
                }}>
                    <Typography
                        variant="h6"
                        style={{
                            color: '#152C73',
                            fontWeight: 600,
                            letterSpacing: '0.5px',
                            position: 'relative',
                            paddingLeft: '1rem',
                            display: 'flex',
                            alignItems: 'center'
                        }}
                    >
                        <span style={{
                            position: 'absolute',
                            left: 0,
                            top: '10%',
                            bottom: '10%',
                            width: '4px',
                            backgroundColor: '#152C73',
                            borderRadius: '2px'
                        }}></span>
                        Combined Table Data
                    </Typography>
                    <IconButton
                        aria-label="download"
                        size="large"
                        color="primary"
                        style={{
                            borderRadius: '8px',
                            padding: '8px',
                            backgroundColor: 'rgba(21, 44, 115, 0.05)',
                            transition: 'all 0.3s ease',
                            position: 'relative',
                            overflow: 'hidden'
                        }}
                        sx={{
                            '&:hover': {
                                backgroundColor: 'rgba(21, 44, 115, 0.15)',
                                transform: 'translateY(-2px)',
                                boxShadow: '0 4px 8px rgba(21, 44, 115, 0.2)'
                            },
                            '&:active': {
                                transform: 'translateY(0)',
                                boxShadow: '0 2px 4px rgba(21, 44, 115, 0.2)'
                            },
                            '&:disabled': {
                                backgroundColor: 'rgba(0, 0, 0, 0.05)',
                                color: 'rgba(0, 0, 0, 0.3)'
                            }
                        }}
                        onClick={handleDownloadCSV}
                        disabled={!combinedCsvFileKey}
                    >
                        <DownloadIcon fontSize="medium" />
                    </IconButton>
                </div>
            )}


            {/* Display the combined table if data exists */}
            {combinedTableData.length > 0 && (
                <CombinedTableDisplay data={combinedTableData} />
            )}


            {loading && (
                <div style={overlayStyle}>
                    <div className="loader"></div>
                </div>
            )}

            {/* <CleanedFixedSizeTable data={cleanedData} />  */}

        </>
    );
}

export default UploadAndCleanData;